import { createContext, PropsWithChildren, useContext } from "react";
import type { ITagIconTag } from "src/components-mui/base/table-scrollable/components/entity/tag-icon.types";

const TagTooltipsContext = createContext<ITagIconTag[] | undefined>(undefined);

interface ITagTooltipsProviderProps {
    tagsWithTooltips?: ITagIconTag[];
}

export const TagTooltipsProvider = ({ tagsWithTooltips, children }: PropsWithChildren<ITagTooltipsProviderProps>) => (
    <TagTooltipsContext.Provider value={tagsWithTooltips}>{children}</TagTooltipsContext.Provider>
);

export const useTagTooltips = () => useContext(TagTooltipsContext);
